import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=5e72e9a2&scoped=true"
import script from "./Contest.vue?vue&type=script&lang=js"
export * from "./Contest.vue?vue&type=script&lang=js"
import style0 from "./Contest.vue?vue&type=style&index=0&id=5e72e9a2&prod&lang=scss"
import style1 from "./Contest.vue?vue&type=style&index=1&id=5e72e9a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72e9a2",
  null
  
)

export default component.exports